module.exports = __webpack_public_path__ + "img/libu-ios-download.505c7a72.png";